import React, { FC, useEffect, useState } from 'react';
import { IShowcaseSection } from '../../interfaces/umbracoNodes/contentSection';
import Button from '../base/button';
import { StyledRichText } from '../base/richTextStyleWrapper/richTextStyleWrapper';
import { A, H2 } from '../base/typography';
import * as StyledSection from './showcaseSection.styles';

interface Props {
	content: IShowcaseSection;
}

const ShowcaseSection: FC<Props> = ({ content }) => {
	const [showVideo, setShowVideo] = useState(false);

	useEffect(() => {
		if (!showVideo && content.Values.Image) {
			if (content.Values.Image.Src.includes('.mp4')) {
				setShowVideo(true);
			}
		}
	}, [showVideo, setShowVideo, content]);

	return (
		<StyledSection.Wrapper>
			<StyledSection.ShowcaseSectionColumns>
				<StyledSection.ImageColumn
					tablet={content.Values.Title === '' ? 1 : 1 / 2}
					right={!content.Values.ImageLeft}>
					{!showVideo && content.Values.Image && (
						<StyledSection.ShowcaseSectionImage
							containImage={content.Values.ContainImage}
							hidePlaceholder={content.Values.ContainImage}
							image={content.Values.Image.Src}
						/>
					)}
					{showVideo && (
						<StyledSection.HeroVideo controls>
							<StyledSection.VideoSource src={content.Values.Image.Src} />
						</StyledSection.HeroVideo>
					)}
				</StyledSection.ImageColumn>
				{content.Values.Title && (
					<StyledSection.ContentColumn tablet={1 / 2} left={!content.Values.ImageLeft}>
						<StyledSection.ContentWrapper left={!content.Values.ImageLeft}>
							{content.Values.Subtitle && content.Values.Subtitle.length > 0 && (
								<StyledSection.Subtitle>{content.Values.Subtitle}</StyledSection.Subtitle>
							)}
							{content.Values.Title && content.Values.Title.length > 0 && (
								<H2 marginBottom="3rem" marginTop="1rem">
									{content.Values.Title}
								</H2>
							)}
							<StyledRichText content={content.Values.Content} />
							{content.Values.Button && (
								<StyledSection.ButtonWrapper>
									<A to={content.Values.Button.Url} target={content.Values.Button.Target}>
										<Button>{content.Values.Button.Name}</Button>
									</A>
								</StyledSection.ButtonWrapper>
							)}
						</StyledSection.ContentWrapper>
					</StyledSection.ContentColumn>
				)}
			</StyledSection.ShowcaseSectionColumns>
		</StyledSection.Wrapper>
	);
};

export default ShowcaseSection;
